import SectionLooksGood from "./SectionLooksGood";
import imageBeachDesktop from "../../public/img/hero/beach_desktop.jpg";
import imageBeachMobile from "../../public/img/hero/beach_mobile.jpg";
import SectionRegisterCta from "./SectionRegisterCta";
import Container from "../Container";
import {useRouter} from "next/router";
import localized from "../../locale/locales";
import Title from "../Title";

export default function SectionJobsCta({form = 'default'}) {
    const {locale} = useRouter();
    const {sections: {jobsCta, jobsCtaSummerFull}} = localized[locale];

    let lang;

    if (locale === 'cs') {
        lang = {
            title: jobsCtaSummerFull.title.localize(),
            body: jobsCtaSummerFull.body,
            cta: jobsCtaSummerFull.cta
        };
    } else {
        lang = {
            title: jobsCta.title.localize(),
            body: jobsCta.body,
            cta: jobsCta.cta
        };
    }

    return (
        <div className="w-screen overflow-hidden">
            <SectionLooksGood imageDesktop={imageBeachDesktop} imageMobile={imageBeachMobile}/>

            <div className="relative pt-20 pb-24 md:py-24 flex flex-col gap-14">
                <SectionRegisterCta href={form === 'summer' ? '/register-summer' : '/register'} cta={lang.cta}>
                    <Title className={`${locale === 'cs' ? 'max-w-[20ch]' : 'max-w-[17ch] sm:max-w-[26ch]'}`}>
                        {lang.title.localize()}
                    </Title>
                </SectionRegisterCta>

                <Container className="text-center">
                    <p className="max-w-[57ch] leading-[1.6] mx-auto">
                        {lang.body}
                    </p>
                </Container>
            </div>
        </div>
    )
}